import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Percent, Sparkles } from 'lucide-react';

const PromoBanner = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="relative rounded-3xl overflow-hidden bg-gradient-to-r from-primary-500 via-primary-600 to-secondary-600 p-12 md:p-20"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
        >
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-72 h-72 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/3" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/3" />
          <div className="absolute top-1/2 left-1/2 w-32 h-32 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2" />

          {/* Floating icons */}
          <motion.div
            className="absolute top-10 right-20 text-white/20"
            animate={{ rotate: [0, 10, -10, 0], y: [0, -10, 0] }}
            transition={{ duration: 4, repeat: Infinity }}
          >
            <Percent size={80} />
          </motion.div>
          <motion.div
            className="absolute bottom-10 left-20 text-white/20"
            animate={{ rotate: [0, -10, 10, 0], y: [0, 10, 0] }}
            transition={{ duration: 5, repeat: Infinity }}
          >
            <Sparkles size={60} />
          </motion.div>

          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="text-center lg:text-left">
              <motion.span
                className="inline-block px-4 py-1.5 bg-white/20 backdrop-blur-sm text-white text-sm font-semibold rounded-full mb-4"
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
              >
                Limited Time Offer
              </motion.span>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
                Your Everyday<br />
                <span className="text-yellow-300">Cooking Staples</span>
              </h2>
              <p className="text-white/90 text-lg md:text-xl max-w-lg">
                Now Easier on Budget. Up to <span className="font-bold text-yellow-300">30% OFF</span> on essential items this week.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/shop">
                <motion.button
                  className="px-8 py-4 bg-white text-primary-600 rounded-full font-bold text-lg shadow-xl flex items-center gap-2 whitespace-nowrap"
                  whileHover={{ scale: 1.05, boxShadow: '0 20px 40px -10px rgba(0,0,0,0.3)' }}
                  whileTap={{ scale: 0.95 }}
                >
                  Shop Deals Now <ArrowRight size={20} />
                </motion.button>
              </Link>
              <Link to="/shop">
                <motion.button
                  className="px-8 py-4 bg-white/20 backdrop-blur-sm border-2 border-white/40 text-white rounded-full font-bold text-lg whitespace-nowrap hover:bg-white/30 transition-colors"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  View All Offers
                </motion.button>
              </Link>
            </div>
          </div>

          {/* Product preview cards floating */}
          <motion.div
            className="hidden lg:block absolute -bottom-8 right-20 bg-white rounded-2xl p-4 shadow-2xl"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            animate={{ y: [0, -10, 0] }}
          >
            <div className="flex items-center gap-3">
              <img src="https://images.unsplash.com/photo-1586201375761-83865001e31c?w=100" alt="Rice" className="w-16 h-16 object-cover rounded-xl" />
              <div>
                <p className="font-bold text-gray-900">Chozha Rice</p>
                <p className="text-primary-600 font-bold">£12.99 <span className="text-gray-400 line-through text-sm">£16.66</span></p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default PromoBanner;
